import '@node_modules/nes.css/css/nes.css';
// import '@node_modules/nes.css/scss/nes.scss';
import '@components/index.scss';
import '@node_modules/highlight.js/styles/far.css';
